export default {
  ResinvoiceHistory: "Invoice History",
  RessearchInvoice: "Search Invoice Number...",
  ResnoInvoices: "No invoices found",
  Resinvoice: "Invoice",
  Resorder: "Order",
  Resdate: "Date",
  Restotal: "Total",
  Resstatus: "Status",
  Resview: "View",

  ResinvoiceDetails: "Invoice Details",
  ResdownloadInvoice: "Download Invoice PDF",
  ResinvoiceIdNotFound: "Invoice ID not found",
  ResdownloadFailed: "Failed to download invoice PDF",

  RessupplierDetails: "Supplier Details",
  Resname: "Name",
  Rescontact: "Contact",
  Resmobile: "Mobile",
  Resemail: "Email",

  Resitems: "Items",
  Resproduct: "Product",
  Resqty: "Qty",
  Resprice: "Price",
  Resdiscount: "Discount",
};